import { createStyles } from '@material-ui/core/styles';

const BORDER = '1px solid #E6E6EB';

const styles = createStyles((theme) => ({
  card: {
    background: '#fff',
    border: BORDER,
    borderRadius: 12,
    overflow: 'hidden',
    margin: '0 0 24px'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '24px 30px',
    borderBottom: BORDER
  },
  column: {
    padding: '30px',
    [theme.breakpoints.up('md')]: {
      '&:not(:first-child)': { borderLeft: BORDER }
    },
    [theme.breakpoints.down('sm')]: {
      '&:not(:first-child)': { borderTop: BORDER }
    }
  },
  sectionDivider: {
    borderTop: BORDER,
    margin: '24px 0'
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 12,
    padding: '16px 30px',
    borderTop: BORDER
  },
  quoteStrip: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '16px 30px',
    background: '#F4F4F7',
    borderTop: BORDER
  },
  fieldLabel: {
    display: 'block',
    fontWeight: 600,
    fontSize: 13,
    marginBottom: 6
  },
  required: {
    color: theme.palette.primary.main
  },
  hint: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: 6
  },
  field: {
    marginBottom: 20
  },
  iconBadge: {
    width: 40,
    height: 40,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 14,
    flexShrink: 0
  }
}));

export default styles;
